import { AxiosResponseHeaders, RawAxiosResponseHeaders } from 'axios';

export enum HEADERS {
  DEVICE_ID = 'x-device-id',
}

interface Provider {
  applyDeviceIdHeaders(): { [p: string]: string | null };
  setUserDeviceId(deviceId: string): void;
}

export class SessionProvider implements Provider {
  private DEVICE_ID: string | null = null;
  private DEVICE_ID_KEY = HEADERS.DEVICE_ID;
  private userDeviceId?: string | null;

  constructor() {}

  get deviceId() {
    if (!this.DEVICE_ID) {
      this.deviceId = localStorage.getItem(this.DEVICE_ID_KEY);
    }
    return this.DEVICE_ID;
  }

  set deviceId(deviceId: string | null) {
    if (deviceId) {
      this.DEVICE_ID = deviceId;
      localStorage.setItem(this.DEVICE_ID_KEY, this.DEVICE_ID);
    }
  }

  setUserDeviceId(deviceId: string | null | undefined) {
    if (!deviceId) return;
    this.userDeviceId = deviceId;
    localStorage.setItem(this.DEVICE_ID_KEY, this.userDeviceId);
  }

  setUserHeaders(headers: RawAxiosResponseHeaders | AxiosResponseHeaders) {
    this.setUserDeviceId(headers[HEADERS.DEVICE_ID]);
  }

  applyDeviceIdHeaders() {
    return { [HEADERS.DEVICE_ID]: this.deviceId };
  }
}
